import {useState} from "react";
import {Alert, Box, Button, Dialog, DialogContent, TextField, Typography} from "@mui/material";
import {verifyKioskStaffPin} from "../api/kioskOrders";
import kioskLogout from "../logout";

export default function StaffAccessDialog({open, onClose, systemData}) {
  const [pin, setPin] = useState("");
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await verifyKioskStaffPin(pin);
      if (response.error === 0) setVerified(true);
      else setError(response.msg || "PIN 錯誤");
    } catch {
      setError("無法驗證，請確認網路連線");
    } finally {
      setLoading(false);
    }
  };

  const close = () => {
    setPin("");
    setVerified(false);
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogContent sx={{p: 4}}>
        <Typography sx={{fontSize: 28, fontWeight: 900}}>店員維護</Typography>
        {!verified ? (
          <Box sx={{display: "grid", gap: 2, mt: 3}}>
            <TextField autoFocus type="password" inputMode="numeric" label="店員 PIN" value={pin} onChange={(event) => setPin(event.target.value)} onKeyDown={(event) => event.key === "Enter" && verify()} inputProps={{maxLength: 12, style: {fontSize: 24, letterSpacing: 8}}}/>
            {error && <Alert severity="error">{error}</Alert>}
            <Button variant="contained" onClick={verify} disabled={loading || !pin}>驗證</Button>
          </Box>
        ) : (
          <Box sx={{display: "grid", gap: 2, mt: 3}}>
            <Alert severity="success">已驗證店員身分</Alert>
            <Box sx={{p: 2.5, bgcolor: "#F7F1E8", borderRadius: 3}}>
              <Typography>機台：{systemData?.device_name || systemData?.name || "Kiosk"}</Typography>
              <Typography>帳號模式：{systemData?.client_mode}</Typography>
              <Typography>網路：{navigator.onLine ? "已連線" : "已離線"}</Typography>
            </Box>
            <Button variant="outlined" onClick={() => window.location.reload()}>重新抓取資料</Button>
            <Button color="error" variant="outlined" onClick={kioskLogout}>登出機台</Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
